import { React, useMemo, useCallback, useEffect } from "react";
import useGetSeasonList from "../../hooks/useGetSeasonList";
import { changeSelectedSeasonIdForQuestFilter } from "../../redux/slices/SeasonSlice";
import { useDispatch, useSelector } from "react-redux";
import { SeasonTypeConst } from "../../core/constant/seasonType";
import Select from "react-select";
import { FormText } from "reactstrap";
import QuestSerialValidationModal from "./QuestSerialValidationModal";
import _ from "lodash";
import { Row, Col } from "reactstrap";

const QuestValidationFilterBar = ({ allQuests, openedByDefault, refreshMainPage, refreshPage }) => {
  const { SeasonList } = useGetSeasonList();
  let quests = _.cloneDeep(allQuests);
  const { selectedSeasonIdForQuestFilter } = useSelector((state) => ({ ...state.seasonList }));
  const dispatch = useDispatch();

  const INTER_EXPEDITION_VALUE = "__INTER__";

  const seasonListOptions = useMemo(() => {
    const seasons = SeasonList
      .filter((season) => season.seasonType !== SeasonTypeConst.future)
      .map((season) => ({
        value: season.seasonId,
        label: season.title
          ? `${season.title} - n°${season.seasonNumber}`
          : `Exped. - n°${season.seasonNumber}`,
      }));

    return [{ value: INTER_EXPEDITION_VALUE, label: "Interexpédition" }, ...seasons];
  }, [SeasonList]);

  const renderSeasonFilterItem = useCallback(() => {
    return (
      <Select
        name="seasonListFilter"
        id="seasonListFilter"
        autoComplete="off"
        value={seasonListOptions.find((e) => e.value === selectedSeasonIdForQuestFilter)}
        isSearchable
        isClearable
        onChange={(e) => {
          const selectedSeasonId = e?.value;
          dispatch(changeSelectedSeasonIdForQuestFilter(selectedSeasonId));
        }}
        noOptionsMessage={() => "Pas d'options"}
        placeholder="Filtre par statut"
        options={seasonListOptions}
      />
    );
  }, [selectedSeasonIdForQuestFilter, seasonListOptions]);

  return (
    <Row>
      <Col md="4">
        <div className="d-flex justify-content-end">
          <h6 className="lh-lg mx-2"> Exped. &nbsp;</h6>
          <div className="w-100">
            {renderSeasonFilterItem()}
            <FormText>Vos quêtes par expédition</FormText>
          </div>
        </div>
      </Col>

      <Col className="d-flex justify-content-end sequential-validation-loop">
        <QuestSerialValidationModal
          quests={quests}
          openedByDefault={openedByDefault}
          refreshMainPag
          refreshMainPage={refreshMainPage}
          refreshPage={refreshPage}
        ></QuestSerialValidationModal>
      </Col>
    </Row>
  );
};

export default QuestValidationFilterBar;
